import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const { form, token, game_id } = data;
	const apiData: PropertyType = {
		sid: token,
		game_id,
		partners: form.gamePartners,
	};

	return apiData;
};
